import { ContentBlock } from "@/libraries/design/components";
import {
    ContentBlockAlignment,
    ContentBlockTitleAs,
    ContentBlockCtaProps
} from "@/libraries/design/components/content-block/src/content-block";
import { LinkType } from "@/libraries/design/components/link/src/link";
import { useLocalizedHref } from "@/libraries/web-framework";
import { RichTextComponent } from "@/templates/agile-hub/src/sections/components/body-text";

// More props will be coming in the future
export type UniformContentBlockProps = {
    title?: string;
    text?: string;
    richText?: string;
    eyebrow?: string;
    titleAs?: ContentBlockTitleAs;
    buttonHref?: {
        path: string;
    };
    buttonLabel?: string;
    linkHref?: {
        path: string;
    };
    linkText?: string;
    linkType?: LinkType;
    alignment?: ContentBlockAlignment;
    imageUrl?: string;
    imageAlt?: string;
    iconUrl?: string;
    iconSize?: "x-small" | "small" | "medium" | "large";
};

const UniformContentBlock = (props: UniformContentBlockProps) => {
    const localizedLinkHref = useLocalizedHref(props.linkHref?.path ?? "");
    const localizedButtonHref = useLocalizedHref(props.buttonHref?.path ?? "");

    if (props.linkHref) {
        props.linkHref.path = localizedLinkHref;
    }
    if (props.buttonHref) {
        props.buttonHref.path = localizedButtonHref;
    }

    const callToActionProps: ContentBlockCtaProps | undefined =
        transformCtaProps(props);

    return (
        <ContentBlock
            title={props.title}
            text={
                props.richText ? (
                    <RichTextComponent name={null} text={props.richText} />
                ) : (
                    props.text
                )
            }
            titleAs={props.titleAs}
            eyebrow={props.eyebrow}
            alignment={props.alignment}
            callToActionProps={callToActionProps}
            pictureProps={
                props.imageUrl
                    ? {
                          image: {
                              src: props.imageUrl,
                              alt: props.imageAlt ?? ""
                          }
                      }
                    : undefined
            }
            icon={
                props.iconUrl
                    ? {
                          linkedIcon: {
                              url: props.iconUrl,
                              size: props.iconSize
                          }
                      }
                    : undefined
            }
        />
    );
};

function transformCtaProps({
    buttonHref,
    buttonLabel,
    linkHref,
    linkText,
    linkType
}: UniformContentBlockProps): ContentBlockCtaProps | undefined {
    const isButton = !!buttonHref?.path && !!buttonLabel;
    const isLink = !!linkHref?.path && !!linkText;

    if (isButton || isLink) {
        const ctaProps = {
            button: isButton
                ? {
                      href: buttonHref.path
                  }
                : undefined,
            buttonText: buttonLabel ?? undefined,
            link: isLink
                ? {
                      href: linkHref.path,
                      text: linkText,
                      type: linkType
                  }
                : undefined
        } as ContentBlockCtaProps;

        return ctaProps;
    }

    return undefined;
}

export default UniformContentBlock;
